import { TaskName } from "./name/task-name";
import { TaskDueDate } from "./due-date/task-due-date";
import { TaskPriority } from "./priority/task-priority";
import { TaskStatus } from "./status/task-status";
import { TaskType } from "./type/task-type";
import { TaskCreatedAgo } from "./created-date/task-created-ago";
import { TaskCompletedDate } from "./completed-date/task-completed-date";
import { TaskWorkStatus } from "./work-status/task-work-status";
import { TaskRecurrence } from "./recurrence/task-recurrence";

/**
 * Поля задачи, каждое своим компонентом; подкомпонент принимает задачу целиком —
 * `<Task.Priority data={task} />`, — поэтому вызывающему не нужно знать, что
 * приоритет лежит в `priority.value.value`.
 */
export const Task = {
  Name: TaskName,
  DueDate: TaskDueDate,
  Priority: TaskPriority,
  Status: TaskStatus,
  Type: TaskType,
  CreatedAgo: TaskCreatedAgo,
  CompletedDate: TaskCompletedDate,
  WorkStatus: TaskWorkStatus,
  Recurrence: TaskRecurrence,
};
